import { useEffect, useRef } from 'react'
import {useSelector} from "react-redux";

let myMap = null
const ymaps = window.ymaps

const Map = ({coords, address}) => {
    const map = useRef(null)
    const mobile = useSelector(state => state.mobile);

    useEffect(() => {

      ymaps.ready(function () {

        if (!myMap) {
          myMap = new window.ymaps.Map(map.current, {
              center: coords,
              zoom: 17,
              controls: []
          })

          myMap.controls.add('zoomControl', {
              size: 'small',
              float: 'none',
              position: {
                top: '50px',
                left: '8px'
              }
          });

          myMap.behaviors.disable('scrollZoom');
          if (mobile) {
            myMap.behaviors.disable('drag');
          }

          const myPlacemark = new window.ymaps.Placemark(coords, {
                  //hintContent: `<div class="apartment-search__map-hint">${address}</div>`,
              },
              {
                  iconLayout: 'default#image',
                  iconImageHref: '/img/contacts/point.svg',
                  iconImageSize: [146, 84],
                  iconImageOffset: [-73, -84],
                  balloonShadow: false,
                  hideIconOnBalloonOpen: false,
              })

          myMap.geoObjects.add(myPlacemark);
        }
      })

      return () => {
          if (myMap) {
              myMap.destroy()
          }
          myMap = null
      }
  }, [])

  return(
    <div id="map" ref={map}></div>
  )
}

export default Map
